<div class="card-header">
    <h2 class="card-title">{{ categoryValue.category.name }}</h2>
</div>
<div class="card-body">
    <div class="row">
        <div class="col-12 col-md-5 career-valuation-category-section career-valuation-gauge">
            <dx-linear-gauge [value]="categoryValue.actualValue">
                <dxo-linear-gauge-geometry orientation="horizontal"> </dxo-linear-gauge-geometry>
                <dxo-linear-gauge-scale [startValue]="0"
                                        [endValue]="categoryValue.idealValue"
                                        [allowDecimals]="false"> </dxo-linear-gauge-scale>
                <dxo-linear-gauge-label position="bottom"> </dxo-linear-gauge-label>
                <dxo-linear-gauge-value-indicator type="textCloud"
                                                  [color]="indicatorColor"
                                                  [arrowLength]="20">
                    <dxo-linear-gauge-text [customizeText]="getCustomText"> </dxo-linear-gauge-text>
                </dxo-linear-gauge-value-indicator>
            </dx-linear-gauge>
        </div>
        <div class="col-12 col-md-7 career-valuation-category-section career-valuation-notes"
             [froalaView]="categoryValue.notes"></div>
    </div>
</div>
